<template>
  <div>
    <h3 class="header-title">Learning Payment</h3>
    <label>Let’s see your tuition student payment.</label>
    <br />
    <label
      >
      You have subscribed to the {{ user.packageName }} package, which is valid until  {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} {{ user.invoiceprice }} and 
      includes a limit of {{ check.NumberOfStudent }} students and <span v-if="check.TotalTeacher === 0">Unlimited</span><span v-else>{{ check.TotalTeacher }} </span> teachers.
      
      </label
    >
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your payment student !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
          >X ERROR ! Your subscription package has expired. Please renew your
          current subscription or upgrade to a new package.
        </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()">Renew</CButton>
          </CCol>

        </CRow>
       
      </CAlert>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
    <CCol sm="12" class="mt-4">

      <CRow>
        <CCol sm="4">
          <CInput
            type="text"
            placeholder="Search text"
            v-model.lazy="SearchQuery"
            @change="ApplyFilter()"
          />
        </CCol>
        <CCol sm="4"></CCol>
        <CCol sm="4" class="text-right">
          <CButton
              type="submit"
              color="success"
              @click="GoToGenerate()"
              >Generate Payment</CButton>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="3">
          <v-select
            v-model="selectedNote"
            :options="noteOptions"
            label="Note"
            class="custom-btn-blue style-chooser"
            @input="FilteredData()"
          ></v-select>
        </CCol>

        <CCol sm="3">
          <v-select
            v-model="selectedPaid"
            :options="ispaidOptions"
            label="IsPaid"
            class="custom-btn-blue style-chooser"
            @input="FilteredData()"
          ></v-select>
        </CCol>
        <CCol sm="3">
          <v-select
            v-model="selectedMethod"
            :options="methodOptions"
            label="Method"
            class="custom-btn-blue style-chooser"
            @input="FilteredData()"
          ></v-select>
        </CCol>

        <CCol sm="3">
        </CCol>
      </CRow>
    </CCol>

    <!-- <CCol sm="12">
      <CCol sm="12">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="2">
            <v-select
              v-model="selectedNote"
              :options="noteOptions"
              label="Note"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="2">
            <v-select
              v-model="selectedPaid"
              :options="ispaidOptions"
              label="IsPaid"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="2">
            <v-select
              v-model="selectedMethod"
              :options="methodOptions"
              label="Method"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="6"> </CCol>
        </CRow>
      </CCol>
       -->

      <!-- <CCol sm="12">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="2">
            <v-select
              v-model="selectedNote"
              :options="noteOptions"
              label="Note"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="2">
            <v-select
              v-model="selectedPaid"
              :options="ispaidOptions"
              label="IsPaid"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="2">
            <v-select
              v-model="selectedMethod"
              :options="methodOptions"
              label="Method"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="6"> </CCol>
        </CRow>
    </CCol> -->
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="user.validTo < currentDate ? FilteredPayments.slice(0, 5) : FilteredPayments"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
        >
          <template #StudentNote="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Note }}
              </h6>
              <div class="small text-muted">
                Student : {{ item.StudentName }}
              </div>
              <div class="small text-muted">Grade : {{ item.Grade }}</div>
              <div class="small text-muted">Class : {{ item.Class }}</div>
            </td>
          </template>

          <template #Invoice="{ item }">
            <td>
              <div class="small text-muted">
                Invoice ID : <strong>{{ item.InvoiceId }}</strong>
              </div>
              <div class="small text-muted">
                Invoice : {{ item.PaymentFee }}
              </div>
              <div class="small text-muted">Discount : {{ item.Discount }}</div>
              <div class="small text-muted">
                Final Amount : {{ item.PaymentFee - item.Discount }}
              </div>
              <div class="small text-muted">
                Rate Type : {{ item.RateType }}
              </div>
            </td>
          </template>

          <template #AdditionalPayment="{ item }">
            <td>
              <tr
                v-for="add in item.TuitionAdditionalPayments"
                v-bind:key="add.Id"
              >
                <li>{{ add.PaymentInfo }} - RM {{ add.PaymentFee }}</li>
              </tr>
            </td>
          </template>

          <template #IsPaid="{ item }">
            <td>
              <div v-if="item.IsPaid === true">
                <CBadge color="success">Yes</CBadge>
              </div>
              <div v-else><CBadge color="danger">No</CBadge></div>
            </td>
          </template>

          <template #PaymentMethod="{ item }">
            <td>
              {{ item.Method }}
            </td>
          </template>

          <template #Description="{ item }">
            <td>
              {{ item.ParentPaymentTime | moment("DD/MM/YYYY hh:mm A") }}
            </td>
          </template>

          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenSetPayment(item)"
                  >Set Payment</CDropdownItem
                >
                <CDropdownItem @click="OpenAdditional(item)"
                  >Additional Payment</CDropdownItem
                >

                <CDropdownItem @click="OpenPrintInvoice(item)"
                  >Print Invoice</CDropdownItem
                >

                 <CDropdownItem @click="OpenDeletePayments(item)"
                  >Delete Payments</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>

        <CModal
          title="Add Additional Payment"
          size="md"
          :show.sync="AdditionalModal"
        >
          <div>
            <h6><strong>ADDITONAL PAYMENT</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CButton
                  class="button btn-success mr-2 mt-2"
                  @click="AddPayment"
                  size="sm"
                >
                  <CIcon name="cil-plus" />Add New Additional Payment
                </CButton>

                <CCol sm="12">
                  <table class="table mt-3">
                    <thead>
                      <th>Payment Info</th>
                      <th>Rate</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="item in adds" v-bind:key="item.Id">
                        <td>{{ item.PaymentInfo }}</td>
                        <td>{{ item.PaymentFee }}</td>
                        <td>
                          <CButton
                            type="button"
                            class="btn-danger"
                            @click="OpenDeleteAdditionalPayment(item)"
                            >X Delete</CButton
                          >
                        </td>
                      </tr>
                      <tr
                        v-for="(item, index) in addition"
                        v-bind:key="item.Id"
                      >
                        <td>
                          <CInput type="text" v-model="item.PaymentInfo" />
                        </td>
                        <td>
                          <CInput type="text" v-model="item.PaymentFee" />
                        </td>
                        <td>
                          <button
                            type="button"
                            class="text-center button btn-xs btn-danger"
                            v-on:click="removeRow(index)"
                          >
                            -
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="SubmitAdditionalPayment()"
              >Proceed</CButton
            >
          </template>
        </CModal>

        <CModal title="Set Payment" size="md" :show.sync="SetPaymentModal">
          <div>
            <h6><strong>STUDENT PAYMENT</strong></h6>
            <CRow>
              <CCol md="4">
                <strong>Description</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ receipt.Note }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Student Name</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ receipt.StudentName }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Invoice</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ receipt.InvoiceId }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Discount</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ user.currencyCode}}  {{ receipt.Discount }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Additional Payment</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ user.currencyCode}}  {{ receipt.TotalAdditional }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong>Final Payment</strong>
              </CCol>
              <CCol md="8">
                <span
                  >: {{ user.currencyCode}} 
                  {{
                    receipt.PaymentFee -
                    receipt.Discount +
                    receipt.TotalAdditional
                  }}
                </span>
              </CCol>
            </CRow>
            <br />
            <hr />
            <CRow>
              <CCol md="4">
                <strong>Payment Amount</strong>
              </CCol>
              <CCol md="8">
                <span>: {{ user.currencyCode}}  {{ receipt.PaymentAmount }} </span>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <strong v-if="receipt.Balance >= 0">Balance Exceed</strong>
                <strong v-else>Balance Remaining</strong>
              </CCol>
              <CCol md="8">
                <span
                  >: {{ user.currencyCode}} 
                  {{
                    receipt.PaymentAmount -
                    (receipt.PaymentFee -
                      receipt.Discount +
                      receipt.TotalAdditional)
                  }}</span
                >
              </CCol>
            </CRow>
            <hr />
            <CRow>
              <CCol sm="12" class="mt-2">
                Change Payment Amount: <br />
                <CInput type="text" v-model="PaymentAmounts" />
              </CCol>
            </CRow>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="SubmitSetPayment()"
              >Proceed</CButton
            >
          </template>
        </CModal>

        <CModal
          title="Delete Payment"
          size="md"
          :show.sync="InactivePaymentModal"
        >
          <div>
            <CCol sm="12">
              <CRow>
                <CCol sm="4">Description: </CCol>
                <CCol sm="8">{{ receipt.Note }}</CCol>

                <CCol sm="4">Student Names: </CCol>
                <CCol sm="8">{{ receipt.StudentName }} </CCol>

                <CCol sm="4">Invoice: </CCol>
                <CCol sm="8">{{ receipt.InvoiceId }} </CCol>

                <CCol sm="4">Discount: </CCol>
                <CCol sm="8">{{ receipt.Discount }} </CCol>

                 <CCol sm="4">Final Payment: </CCol>
                <CCol sm="8">{{ receipt.PaymentFee - receipt.Discount}}</CCol>

                <CCol sm="12" class="mt-3">
                    Are you sure you want to delete this payment data?
                </CCol>
              </CRow>
            </CCol>
          
            <br />
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateStudentPaymentStatus()"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal
          title="Generate Payment"
          size="md"
          :show.sync="GeneratePaymentModal"
        >
          <div>
            <CCol sm="12">
              <CRow>
                <CCol sm="4">Description: </CCol>
                <CCol sm="8">{{ receipt.Note }}</CCol>

                <CCol sm="4">Student Names: </CCol>
                <CCol sm="8">{{ receipt.StudentName }} </CCol>

                <CCol sm="4">Invoice: </CCol>
                <CCol sm="8">{{ receipt.InvoiceId }} </CCol>

                <CCol sm="4">Discount: </CCol>
                <CCol sm="8">{{ receipt.Discount }} </CCol>

                 <CCol sm="4">Final Payment: </CCol>
                <CCol sm="8">{{ receipt.PaymentFee - receipt.Discount}}</CCol>

                <CCol sm="12" class="mt-3">
                    Are you sure you want to delete this payment data?
                </CCol>
              </CRow>
            </CCol>
          
            <br />
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateStudentPaymentStatus()"
              >Proceed</CButton
            ></template
          >
        </CModal>
      </CCol>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  props: [
    "this.$route.params.manualstudentid",
    "this.$route.params.invoiceid",
    "this.$route.params.note",
  ],
  data() {
    return {
      payments: [],
      SearchQuery: "",
      FilteredPayments: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedNote: "ALL MONTH",
      noteOptions: [],

      selectedPaid: "ALL PAID",
      ispaidOptions: [],

      selectedMethod: "ALL METHOD",
      methodOptions: [],
      Busy: false,

      fields: [
        { key: "StudentNote" },
        { key: "Invoice" },
        { key: "AdditionalPayment" },
        { key: "IsPaid" },
        { key: "PaymentMethod" },
        { key: "Description" },
        { key: "Action" },
      ],

      AdditionalModal: false,
      adds: [],
      addition: [],
      FilteredAdditionalPayment: [],
      fieldAdditional: [
        { key: "PaymentInfo" },
        { key: "PaymentFee" },
        { key: "Action" },
      ],
      PaymentInfo: "",
      PaymentFee: "",

      receipt: {},
      SetPaymentModal: false,
      PaymentAmounts: "",
      InactivePaymentModal: false,

      user: {},
      currentDate: new Date().toISOString().substring(0, 10),
      check: {},
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetPayment();
      this.GetPaymentFromOverview();
      this.GetPayment();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },

    RefreshData() {
      this.GetPayment();
    },
    GetPayment() {
      this.Busy = true;
      this.$API
        .get(this.$ViewPaymentStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.payments = response.data;
            this.FilteredPayments = this.payments;

            var gradeNames = _.uniq(_.map(response.data, "Note"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.noteOptions = gradeNames;
            this.noteOptions.unshift("ALL MONTH");

            var classNames = _.uniq(_.map(response.data, "IsPaid"));
            this.ispaidOptions = classNames;
            this.ispaidOptions.unshift("ALL PAID");

            var methods = _.uniq(_.map(response.data, "Method"));
            this.methodOptions = methods;
            this.methodOptions.unshift("ALL METHOD");
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.payments, ["StudentName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ StudentName }) =>
          _.some([
            _.includes(!StudentName || StudentName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredPayments = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredPayments = this.payments;

      if (this.selectedNote !== "ALL MONTH")
        this.FilteredPayments = _.filter(
          this.FilteredPayments,
          (item) => item.Note === this.selectedNote
        );

      if (this.selectedPaid !== "ALL PAID")
        this.FilteredPayments = _.filter(
          this.FilteredPayments,
          (item) => item.IsPaid === this.selectedPaid
        );

      if (this.selectedMethod !== "ALL METHOD")
        this.FilteredPayments = _.filter(
          this.FilteredPayments,
          (item) => item.Method === this.selectedMethod
        );
    },
    OpenAdditional(item) {
      this.invoiceId = item.InvoiceId;

      this.$API
        .get(this.$GetAdditionPaymentStudent + "?invoiceId=" + this.invoiceId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.adds = response.data;
            this.FilteredAdditionalPayment = this.adds;
          }
        });
      this.AdditionalModal = true;
    },

    AddPayment() {
      var lastId = 1;
      var length = this.addition.length;
      if (length > 0) lastId = this.addition[length - 1].Id;

      this.addition.push({
        Id: lastId + 1,
        InvoiceId: this.invoiceId,
        PaymentInfo: "",
        PaymentFee: "",
      });
    },
    removeRow: function (index) {
      this.addition.splice(index, 1);
    },

    async SubmitAdditionalPayment() {
      const formData = new FormData();
      var teacherRateJson = JSON.stringify(this.addition);
      formData.append("additionalPaymentStudentJson", teacherRateJson);

      return this.$API
        .post(this.$InsertAddPaymentStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.AdditionalModal = false;
            this.$dialog.alert("Success saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDeleteAdditionalPayment(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteAdditionalPaymentStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Deleted!");
            this.AdditionalModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    OpenPrintInvoice(item) {
      this.invoiceId = item.Id;
      this.$router.push("/StudentPaymentReceipt?Id=" + this.invoiceId);
    },
    OpenSetPayment(item) {
      this.invoiceId = item.Id;
      this.$API
        .get(this.$GetReceiptStudentPayment + "?Id=" + this.invoiceId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.receipt = response.data;
          }
        });
      this.SetPaymentModal = true;
    },
    async SubmitSetPayment() {
      const formData = new FormData();
      formData.append("Id", this.invoiceId);
      formData.append("PaymentAmount", this.PaymentAmounts);

      return this.$API
        .post(this.$InsertSetPaymentStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.SetPaymentModal = false;
            this.$dialog.alert("Success saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GetPaymentFromOverview() {
      this.Busy = true;
      this.$API
        .get(
          this.$ViewPaymentStudentById +
            "?manualstudentid=" +
            this.manualstudentid +
            "&" +
            "invoiceid=" +
            this.$route.params.invoiceid +
            "&" +
            "note=" +
            this.$route.params.note,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.paymentsById = response.data;

            console.log(this.manualstudentid);
            console.log(this.$route.params.manualstudentid);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
      console.log(this.manualstudentid);
      console.log(this.$route.params.manualstudentid);
    },

    OpenDeletePayments(item) {
      this.invoiceId = item.Id;

       this.$API
        .get(this.$GetReceiptStudentPayment + "?Id=" + this.invoiceId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.receipt = response.data;
          }
        });
      this.InactivePaymentModal = true;
    },
    UpdateStudentPaymentStatus: function () {
      const formData = new FormData();
      formData.append("Id", this.invoiceId);

      return this.$API
        .post(this.$DeletePaymentStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            if(response.data == 1)
            {
              this.InactivePaymentModal = false;
            this.$dialog.alert("Success saved").then(function () {});

            }
            else
            {
                this.InactivePaymentModal = false;
            this.$dialog.alert("Can not delete payment that's already paid").then(function () {});

            }
            
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GoToGenerate() {
      this.$router.push(
        "/GeneratePaymentStudent"
      );
    },
    GoToRenew()
    {
      // window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
      this.$router.push(
        "/Billing"
      );
    }
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
</style>